export enum CardType {
  debit = 'DEBIT_CARD',
  credit = 'CREDIT_CARD',
}

export const EcpSuccess = '01';